import {required, email} from 'vuelidate/lib/validators'

const form = {
  email: {
    size: 0,
    type: 'email',
    name: 'helpEmail',
    label: 'E-mail',
    placeholder: 'Digite o seu e-mail',
    value: null,
    mask: false,
    hasSuccess: true,
    errors: {
      required: ' '
    }
  },
  message: {
    size: 0,
    type: 'textarea',
    name: 'helpMessage',
    label: 'Como podemos ajudar ?',
    placeholder: 'Digite a sua mensagem ',
    value: null,
    errors: {
      required: ' '
    }
  }
}
const requiredFields = ['email', 'message']

const validations = {}
for (let requiredField of requiredFields) {
  validations[requiredField] = {}
  validations[requiredField].value = {}
  validations[requiredField].value.required = required
}

validations['email'] = {
  value: {
    required,
    email
  }
}

validations['message'] = {
  value: {
    required
  }
}
export {form, validations}
